import CxIconVariant from '../../cx/CxIconVariant';
import { FaUser } from "react-icons/fa"; 
import { BsFillSendFill, BsCheck } from "react-icons/bs"; 
import { TbCertificate } from "react-icons/tb"; 
import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxSearcher from '../../cx/CxSearcher';
import CxDate from '../../cx/CxDate';
import CxInput from '../../cx/CxInput';
import CxStatic from '../../cx/CxStatic';
import CxIcon from '../../cx/CxIcon';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxStr from '../../fx/FxStr';
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import { clearStore, StoreComm, StoreClient, StoreVacc, getStoreValue, getStoreValueBo } from "../../gx/GxStore";
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import { useAccess } from '../../hx/useAccess';
import GxPrint from '../../gx/GxPrint';
import GxSlsAuxTable from '../../gx/GxSlsAuxTable';
import * as FxFetch from '../../fx/FxFetch';


const MxAnimalVaccForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.vaccs'));
  const [{ navTo, navStack }] = useNav();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [storeClient, ] = useSessionStorage('StoreClient', StoreClient);
  const [storeComm, setStoreComm] = useSessionStorage('StoreComm', StoreComm);
  const [storeVacc, setStoreVacc] = useSessionStorage('StoreVacc', StoreVacc);

  let r_form = React.useRef(null);
  let r_sls_aux_table = React.useRef(null);
  let r_print = React.useRef(null);

  const rf_ps = React.useRef(null);
  const rf_date = React.useRef(null);
  const rf_next = React.useRef(null);
  let rf_txEmployee = React.useRef(null);
  
  const r_snack_ask_save = React.useRef(null);
  const r_snack_error = React.useRef(null);
  const r_snack_ps_doesnt_exist = React.useRef(null);


  React.useEffect(() => {
    clearStore('StoreComm', storeComm);
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
      r_form.current.getRef("n_vacc.dtFrom").setValToday();
      if (getStoreValueBo('StoreSession', 'boAutoSelEmployee')) {
        rf_txEmployee.current.setKey(getStoreValue('StoreSession', 'inEmployee'));
        rf_txEmployee.current.setVal(getStoreValue('StoreSession', 'txEmployee'));
      }
      rf_ps.current.search(); /* DAQ 2026.05.04 - abre automáticamente ventana de selección de tipo de p-s */
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theValue.startsWith("rv_")) {
      // errores al guardar
      if (lastSaveRv.theValue.startsWith("rv_ps_doesnt_exist")) {
        r_snack_ps_doesnt_exist.current.setOpen(true);
      }
    } else {
      // se guardó exitosamente
      storeVacc.inVacc = lastSaveRv.theValue;
      Promise.all([setStoreVacc(storeVacc)]).then((result) => {
        r_sls_aux_table.current.setTxLinkAuxId(storeVacc.inVacc);
        forceUIUpdate();
      });
      //navBack(); // 2024-07-02 - daq: xq puede querer añadir ps o un recordatorio
    }

  }
  const formDelete = async (rv) => {
  }

  const openFormComm = () => {
    if (storeVacc.inVacc) {
      let record = {};
      record['inVacc'] = storeVacc.inVacc;
      Promise.all([FxFetch.doJsonX('comms/get_inComm_from_inVacc', record)]).then((result) => {
        if (result[0]) {
          FxLog.infox('MxAnimalVaccForm.openFormComm', '...result[0]:', result[0]);
          if (result[0].theValue) {
            // ya hay una comunicación para este evento-calendario, así que la cargamos
            storeComm.inComm = result[0].theValue;
            setStoreComm(storeComm);
            navTo("comm-form");
          } else {
            // no hay una comunicación, así que preparamos form para crear una nueva
            storeComm.inComm = null;
            storeComm.inPs = rf_ps.current.getKey();
            storeComm.inClient = storeClient.inClient;
            storeComm.inAnimal = storeClient.inAnimal;
            storeComm.inVacc = storeVacc.inVacc;
            storeComm.dtFrom = `${rf_next.current.getVal()} 00:00`;

            FxLog.infox('MxAnimalVaccForm.openFormComm', '...storeComm:', storeComm);
      
            let record = {};
            Promise.all([FxFetch.doJsonX('sett/autogen/r', record)]).then((result) => {
              if (result[0].length > 0) {
                let txContent = result[0][0].txContent;
                let txSendType = result[0][0].txSendType;
                FxLog.infox('MxAnimalVaccForm.openFormComm', '...txSendType:', txSendType);
                txContent = txContent.replace('[name]', storeClient.txClient);
                txContent = txContent.replace('[animal]', storeClient.txAnimal);
                txContent = txContent.replace('[ps]', rf_ps.current.getVal());
      
                let record2 = {};
                record2['idValue'] = rf_ps.current.getKey();
                Promise.all([FxFetch.doJsonX("pss/r", record2)]).then((result) => {
                  if (result[0]) {
                    FxLog.infox('MxAnimalVaccForm.openFormComm', '...result[0]:', result[0]);
                    txContent = txContent.replace('[alias]', result[0][0].txPsAlias);
                    storeComm.txContent = txContent;
                    setStoreComm(storeComm);
                    navTo("comm-form");
                  }
                });
              }
            });
          }
        }
      });
      
    } else {
      r_snack_ask_save.current.setOpen(true);
    }
  }

  const psChanged = async (row) => {
    if (row !== null) {
      let nuFrequency = row.original.nuFrequency;
      let next = FxDat.addDays(rf_date.current.getVal(), nuFrequency);
      rf_next.current.setVal(next);
    }
  }

  const doPrintX = async (option) => {
    let inVacc = storeVacc.inVacc;
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inVacc'] = inVacc;
    let record = {};
    r_print.current.setScale(1.5);
    r_print.current.setUrl('vacc/report/certificate');
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  const openFormClient = () => {
    // Abrir en nueva pestaña si el sistema está disponible, o navegar
    // directamente como fallback (móvil / pestañas desactivadas).
    if (getStoreValueBo('StoreSession', 'boShowTabs')) {
      window.__mxMain_openTabWithNavigation('client-form', storeClient.txClient || trans('field.client'), false);
    } else {
      navTo('client-form');
    }
  };

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.patient')}: ${trans('field.vacc')}`}
        xref={r_form}
        url="vaccs" 
        filterIdField='inVacc' 
        filterIdValue={storeVacc.inVacc} 
        onFormLoad={formLoad} 
        onFormSave={isFullAccess() && formSave} 
        onFormDelete={isFullAccess() && formDelete} 
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón de certificado */}
            {storeVacc.inVacc && <CxIconButtonNew icon={<TbCertificate fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={() => doPrintX()} tooltip={trans('field.vacc_certificate')} />}

            {/* botón de comm */}
            {storeVacc.inVacc && isFullAccess() && (
              <CxIconButtonNew 
                icon={
                  <CxIcon 
                    frontIcon={Boolean(storeVacc.boComm==='1') ? <BsCheck /> : null} 
                    frontSize="12px"
                    frontPos={{ bottom: "-2px", right: "-2px" }}
                    frontShell="circle"
                    frontShellColor="yellow"
                    frontColor="var(--ibs_color_black_dark)"
                    backIcon={<BsFillSendFill />} 
                    backSize="20px"
                    backColor="var(--ibs_color_cy_blue)"
                  />
                } 
                classType="ibs_iconbutton_toolbar" 
                onClick={openFormComm} 
                tooltip={trans('field.comm')} 
              />
            )}

            {storeVacc.inVacc && navStack()[navStack().length-2]==='activity-vett-v-list' && <CxIconButtonNew 
              icon={getStoreValueBo('StoreSession', 'boShowTabs') ? (<CxIconVariant variant="client-go" />) : (<FaUser fontSize={19} style={{ margin: '2px 0 0 0px' }} />)} 
              classType="ibs_iconbutton_toolbar" onClick={openFormClient} tooltip={trans('field.open_x', 'field.client')} 
            />}

          </div>
        }
        >
        <CxHidden xref={useRef(null)} dbfield="n_vacc.inClient" value={storeClient.inClient || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_vacc.inAnimal" value={storeClient.inAnimal || ''} />

        <CxStatic label={`${FxStr.join(' / ', storeClient.txClient, storeClient.txAnimal)}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxSearcher xref={rf_ps} label={trans('field.ps')}
          dbfield="n_ps.txPs" dbfieldkey="n_vacc.inPs"
          filter={'n_ps.nuFrequency > 0'}
          onSelection={psChanged}
          url="pss"
          col_id="inPs"
          col_tx="txPs"
          tooltip={`${trans('field.ps')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inPs", show: false },
            { id: "1", Header: trans('field.ps'), accessor: row => rf_ps.current.getTable().highlightText(row["txPs"]), width: '100%' },
            { id: "2", Header: trans('field.frequency'), accessor: "nuFrequency", show: false },
          ]}
          bottomLegend={trans('msg.shows_x_with_x','field.pss','field.frequency')}
          required
        />

        <CxDate xref={rf_date} label={trans('field.date')} dbfield="n_vacc.dtFrom"/>
        <CxDate xref={rf_next} label={trans('field.next')} dbfield="n_vacc.dtNext"/>
        <CxInput xref={useRef(null)} label={trans('field.stamp')} dbfield="n_vacc.txStamp" maxLength={50}/>
        <CxInput xref={useRef(null)} label={trans('field.remarks')} dbfield="n_vacc.txRemarks" maxLength={255}/>

        <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
          dbfield="n_employee.txEmployee" dbfieldkey="n_vacc.inEmployee"
          url="employees" col_id="inEmployee" col_tx="txEmployee"
          tooltip={`${trans('field.employee')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inEmployee", show: false },
            { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
          ]}
        />
        
      </GxForm>

      <GxSlsAuxTable xref={r_sls_aux_table} txLinkAuxTable={'n_vacc'} txLinkAuxId={storeVacc.inVacc} /* rf_txEmployee={rf_txEmployee} */ />

      <GxPrint xref={r_print} />
      
      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <CxSnackbar xref={r_snack_ps_doesnt_exist} severity="error" value={trans('msg.x_doesnt_exist_1','field.product')} />
      <CxSnackbar xref={r_snack_error} severity="error" />
      
    </div>
  );

}

export default MxAnimalVaccForm;
